import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import Axios from 'axios-observable';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import CardMedia from '@material-ui/core/CardMedia';
import InputLabel from '@material-ui/core/InputLabel';
// import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import './index.css';
import { CommonConfig } from '../../../config/common-config';
import Logo from '../../../assets/Login_logo.png';
import Background from '../../../assets/Background.jpg';
import { setLoginSuccessUserDetails, setTennantName, setPolicy } from './store/actions/index';
import PrivacyFooter from '../footer';
import TermsCondition from '../../../components/table/termsCondition';
import DialogContent from '@material-ui/core/DialogContent';
// import DialogTitle from '@material-ui/core/DialogTitle';
// import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';

var CryptoJS = require('crypto-js');

// for dev ENV:
// let host = 'itec.maveric-systems.com/login';
// let host = 'advith.maveric-systems.com/login';

// for Pre-prod ENV:
// let host = 'itec.itecapp.in/login';
// let host = 'advith.itecapp.in/login';
// let host = 'testadvith.itecapp.in/login';

// for prod ENV:
// let host = 'itec.advithitec.in/login';
// let host = 'demo.advithitec.in/login';
// let host = 'api.advithitec.in/login';

let host = window.location.host;
console.log("'host'", host);

// let href = window.location.href;
//console.log("'href'", href);

// let protocol = window.location.protocol;
//console.log("'protocol'", protocol);

// let hostname = window.location.hostname;
//console.log("'hostname'", hostname);

// let pathname = window.location.pathname;
//console.log("'pathname'", pathname);

// let port = window.location.port;
//console.log("'port'", port);

let subDomainName = host.split('.')[0];
console.log("'subDomainName'", subDomainName);

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: '25px',
        marginBottom: '75px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'white',
        padding: '5% 11%',
        borderRadius: '10px',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },

    radioGroupDiv: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        fontFamily: 'Rubik !important',
    },
    media: {
        width: '35%',
        // paddingTop: '3%',
        // paddingBottom: '2%',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
    },
    alignleft: {
        textAlign: 'left',
        marginBottom: '10px',
    },
    selectmainDiv: {
        marginTop: '20px',
    },
    inputSelect: {
        border: '1px solid #ccc',
        width: '100%',
        borderRadius: '4px',
        padding: '10px 14px',
    },
    errorDiv: {
        color: 'red',
        fontSize: '0.8rem',
        marginTop: '10px',
        // paddingLeft: '5px',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    submit: {
        height: '46px',
        boxShadow: 'none !important',
    },

    bgImage: {
        width: '100%',
        backgroundImage: `url(${Background})`,
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        // overflow: 'auto',
    },
    scroll: {
        maxHeight: 'auto',
        minHeight: '93.3vh',
    },
    overflowHidden: {
        overflowY: 'hidden',
    },
    centerAlign: {
        textAlign: 'center',
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '10px 25px',
        letterSpacing: 'normal',
        backgroundColor: '#504cad !important',
        boxShadow: 'none !important',
        fontFamily: 'Rubik',
    },
    buttonSml: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '10px 25px',
        letterSpacing: 'normal',
        backgroundColor: '#504cad !important',
        boxShadow: 'none !important',
        fontFamily: 'Rubik',
        width: '150px',
    },
    '@global': {
        '*::-webkit-scrollbar': {
            width: '0.8em',
        },
        '*::-webkit-scrollbar-track': {
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
        },
        '*::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgb(0 0 0 / 65%)',
        },
    },
    logo: {
        height: '100px',
        width: '100%',
    },
    success: {
        fontFamily: 'Rubik',
        color: 'green',
        fontSize: '14px',
        // fontWeight: '600',
        // paddingBottom: '5px',
    },
    resendButton: {
        color: '#504cad !important',
        cursor: 'pointer !important',
    },
    pointerEvents: {
        pointerEvents: 'none !important',
        color: '#cecece !important',
    },
    toolTipFont: {
        fontFamily: 'Rubik !important',
        fontSize: '12px',
    },
    otherstoolTipFont: {
        fontFamily: 'Rubik !important',
        fontSize: '12px',
        // width: '25%',
        // marginRight: '12px'
    },
}));

function Login(props) {
    const dispatch = useDispatch({});
    const classes = useStyles();
    const [userType, setuserType] = useState('INDIVIDUAL');
    const [companyDiv, setCompanyDiv] = useState('none');
    const [otpDiv, setotpDiv] = useState('none');
    const [OTPmsg, setOTPmsg] = useState('');
    const [requestdata, setrequestdata] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [showLoaderSubmit, setShowLoaderSubmit] = useState(false);
    const [loginbtnStatus, setloginbtnStatus] = useState(false);
    const [resendDisable, setResendDisable] = useState(false);
    const [companyList, setCompanyList] = useState('');
    const [selCompany, setSelCompany] = useState('');
    const [error, setError] = useState('');
    const [errorCorporate, setErrorCorp] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [values, setValues] = React.useState({
        showPassword: false,
    });
    let count = 0;
    const [showDialogBoxTerms, setshowDialogBoxTerms] = React.useState(false);
    const [handleOpen, setHandleOpen] = useState(false);
    const [clearDataNew, setClearDataNew] = useState('');
    const [IMCLogo, setIMCLogo] = useState('');
    const [IMCLogoDefault, setIMCLogoDefault] = useState('');
    const [logoEmpty, setLogoEmpty] = useState('');
    const [loginUserType, setLoginUserType] = useState('');
    const [handleLogo, setHandleLogo] = useState(false);
    const [otpdata, setotpdata] = useState('');

    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/get-imc-logo/${subDomainName}`)
            .then((response) => {
                setIMCLogo(response.config.url);
                setLogoEmpty(response.data);
                if (response.status === 204) {
                    setIMCLogoDefault(response.status);
                }
            })
            .catch(() => {});
        setTimeout(() => {
            setHandleLogo(true);
        }, 600);
    }, []);

    const allImcsOptions = (ff) => {
        const OptionList = ff.map((data) => <option value={data.dbName}>{data.dbName}</option>);
        return OptionList;
    };

    const imcCompanyOptions = (item) => {
        const options = item.map((data) => <option value={data.companyName}>{data.companyName}</option>);
        return options;
    };

    const handleTerms = () => {
        setshowDialogBoxTerms(true);
    };
    const handleTermsClose = () => {
        setshowDialogBoxTerms(false);
    };

    const inactivityTime = function () {
        setTimeout(resend, 1000 * 60 * 5);
        function resend() {
            setResendDisable(false);
        }
    };

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            // tennantName: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().email('Invalid email address').required('Email Required'),
            password: Yup.string().min(3, 'Password must be at least 3 characters').required('Password is required'),
            // tennantName: Yup.string().required('Please Select Domain'),
        }),

        onSubmit: (values) => {
            if (!selCompany && loginUserType === 'CORPORATE') {
                // console.log('selCpmp', selCompany);
                setErrorCorp('Please select the Corporate/Company name');
            }
            setResendDisable(true);
            var encryptPassword = CryptoJS.AES.encrypt(JSON.stringify(values.password), 'Secret@123').toString();
            setShowLoader(true);
            const data = {
                userName: values.email,
                password: encryptPassword,
                tennantName: subDomainName,
                typeReq: userType,
            };
            // var bytes = CryptoJS.AES.decrypt(data.password, 'Secret@123');

            // var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            setrequestdata(data);
            dispatch(setTennantName(data));

            if (selCompany && userType === 'CORPORATE') {
                data.companyName = selCompany;
                Axios.post(`${CommonConfig.dev.baseUrl}/api/auth/corporate`, data).subscribe(
                    (result) => {
                        if (result.data) {
                            dispatch(setLoginSuccessUserDetails({ result }));
                            setShowLoader(false);
                            const policy = result.data.isagreerequired;
                            const resetpwd = result.data.isResetPasswordRequired;
                            dispatch(setPolicy({ policy }));
                            if (policy === true) {
                                handleTerms();
                            } else if (resetpwd === true) {
                                props.history.push('/reset');
                            } else {
                                props.history.push('/menu');
                            }
                        }
                    },
                    (err) => {
                        setShowLoader(false);
                        setError('Please try with valid inputs');
                    }
                );
            } else {
                Axios.post(`${CommonConfig.dev.baseUrl}/api/auth/login`, data).subscribe(
                    (result) => {
                        const user = { result };
                        sessionStorage.setItem('user', JSON.stringify(user));

                        if (result.data) {
                            dispatch(setLoginSuccessUserDetails({ result }));
                            setShowLoader(false);
                            const usertype = result.data.userType;
                            setLoginUserType(usertype);
                            setOTPmsg(result.data.message);
                            ////console.log('result', result);
                            if (usertype === 'SUPERADMIN' || usertype === 'ADMIN') {
                                setloginbtnStatus(true);
                                setError('');
                                setotpDiv('block');
                                setTimeout(() => {
                                    // setHandleOpen(true);
                                    handleClick();
                                }, 1000);
                                inactivityTime();
                            } else if (usertype === 'CORPORATE') {
                                setCompanyList(result.data.list);
                                // const list = compList.map(function (item) {
                                //     return <MenuItem value={item.companyName}>{item.companyName}</MenuItem>;
                                // });
                                //console.log('list',list)
                                // setCompanyList(list);
                                setCompanyDiv('block');
                            }
                            // else if (companyList && usertype === 'CORPORATE'){
                            //     setError('Please select the company');
                            // }
                            else {
                                // console.log('result.data', result.data);
                                const policy = result.data.isagreerequired;
                                const resetpwd = result.data.isResetPasswordRequired;
                                dispatch(setPolicy({ policy }));
                                if (policy === true) {
                                    handleTerms();
                                } else if (resetpwd === true) {
                                    props.history.push('/reset');
                                } else {
                                    props.history.push('/menu');
                                }
                                // const resetpwd = result.data.isResetPasswordRequired;
                                // if (resetpwd === true) {
                                //     props.history.push('/reset');
                                // } else {
                                //     props.history.push('/menu');
                                // }
                            }
                        }
                    },
                    (err) => {
                        setShowLoader(false);
                        setError('Please try with valid inputs');
                    }
                );
            }
        },
    });

    const resndOTP = (values) => {
        console.log(values);
        setResendDisable(true);
        //console.log('count', count++, requestdata);
        // setCount(count + 1);
        setShowLoader(true);
        Axios.post(`${CommonConfig.dev.baseUrl}/api/auth/login`, requestdata).subscribe(
            (result) => {
                const user = { result };
                if (result.data) {
                    setShowLoader(false);
                    setotpdata('');
                    setErrorMessage('');
                    setOTPmsg(result.data.message);
                    ////console.log('result', result);
                    // if (usertype === 'SUPERADMIN' || usertype === 'ADMIN') {
                    setloginbtnStatus(true);
                    setError('');
                    setotpDiv('block');
                    inactivityTime();
                    // }
                }
            },
            (err) => {
                setShowLoader(false);
                setError('Please try with valid inputs');
            }
        );
    };

    const onImcChange = () => {
        setError('');
        formik.values.email = '';
        formik.values.password = '';
    };

    const handleRoleChange = (event) => {
        setuserType(event);
        setShowLoader(false);
        setError('');
        setErrorCorp('');
        switch (event) {
            case 'INDIVIDUAL':
                setCompanyDiv('none');
                setotpDiv('none');
                setloginbtnStatus(false);
                formik.resetForm({ values: '' });
                return true;
            case 'CORPORATE':
                setuserType('CORPORATE');
                setotpDiv('none');
                setloginbtnStatus(false);
                formik.resetForm({ values: '' });
                return true;
            case 'OTHERS':
                setCompanyDiv('none');
                setotpDiv('none');
                formik.resetForm({ values: '' });
                return true;
            default:
                return true;
        }
    };

    const storeOTPvalue = (e) => {
        setotpdata(e.target.value);
    };

    const handleCompChange = (e) => {
        setSelCompany(e.target.value);
        setErrorCorp('');
    };

    const handleClose = () => {
        setHandleOpen(false);
        setloginbtnStatus(false);
        setErrorMessage('');
        setOTPmsg('');
        setotpdata('');
        formik.resetForm();
    };
    const handleClick = () => {
        setHandleOpen(true);
        setClearDataNew('');
    };

    function otpSubmit() {
        // console.log('aaaaaa');
        setShowLoaderSubmit(true);
        const finallyRequest = requestdata;
        finallyRequest.otp = otpdata;
        Axios.post(`${CommonConfig.dev.baseUrl}/api/auth/otp`, finallyRequest).subscribe(
            (result) => {
                if (result.data) {
                    setShowLoaderSubmit(false);
                    dispatch(setLoginSuccessUserDetails({ result }));
                    const policy = result.data.isagreerequired;
                    const resetpwd = result.data.isResetPasswordRequired;
                    dispatch(setPolicy({ policy }));
                    if (policy === true) {
                        handleTerms();
                    } else if (resetpwd === true) {
                        props.history.push('/reset');
                    } else {
                        props.history.push('/menu');
                    }
                }
            },
            (error) => {
                if (error.response) {
                    setShowLoaderSubmit(false);
                    const err = error.response.data;
                    setErrorMessage(err);
                }
            }
        );
    }
    const useStylesBootstrap = makeStyles((theme) => ({
        arrow: {
            color: '#e5e5e5',
        },
        tooltip: {
            backgroundColor: '#e5e5e5',
            color: '#444',
        },
    }));
    function BootstrapTooltip(props) {
        const classes = useStylesBootstrap();

        return <Tooltip arrow classes={classes} {...props} />;
    }

    return (
        <>
            <div className={classes.bgImage}>
                {handleLogo ? (
                    <div className={classes.scroll}>
                        <Container component="main" maxWidth="sm" className={classes.overflowHidden}>
                            <CssBaseline />
                            <div className={classes.paper}>
                                <CardMedia className={classes.media}>
                                    {logoEmpty === '' ? (
                                        IMCLogoDefault === 204 ? (
                                            <div>
                                                <img src={Logo} alt="" className={classes.logo} />
                                            </div>
                                        ) : (
                                            <img src={''} alt="" />
                                        )
                                    ) : (
                                        // <img alt="" />
                                        <img src={IMCLogo} alt="" className={classes.logo} />
                                    )}
                                </CardMedia>
                                <div className="main-container w100">
                                    <div className="radiobtnmainDiv">
                                        <RadioGroup
                                            defaultValue="INDIVIDUAL"
                                            className={classes.radioGroupDiv}
                                            onChange={(e) => handleRoleChange(e.target.value)}
                                            name="customized-radios"
                                        >
                                            <BootstrapTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Typography color="inherit" className={classes.toolTipFont}>
                                                            If you are an individual client and managing <br />
                                                            your account on your own, click on this.
                                                        </Typography>
                                                        {/* <em>{"And here's"}</em> <b>{'some'}</b> <u>{'amazing content'}</u>.{' '}
                                                    {"It's very engaging. Right?"} */}
                                                    </React.Fragment>
                                                }
                                            >
                                                <FormControlLabel
                                                    className="fontRubik"
                                                    value="INDIVIDUAL"
                                                    control={<Radio />}
                                                    label="Individual"
                                                />
                                            </BootstrapTooltip>
                                            <BootstrapTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Typography color="inherit" className={classes.toolTipFont}>
                                                            If you are an individual or non-individual client and your account is being
                                                            managed by a team, click on this.
                                                        </Typography>
                                                        {/* <em>{"And here's"}</em> <b>{'some'}</b> <u>{'amazing content'}</u>.{' '}
                                                    {"It's very engaging. Right?"} */}
                                                    </React.Fragment>
                                                }
                                            >
                                                <FormControlLabel
                                                    className="fontRubik"
                                                    value="CORPORATE"
                                                    control={<Radio />}
                                                    label="Corporate"
                                                />
                                            </BootstrapTooltip>
                                            <BootstrapTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Typography color="inherit" className={classes.otherstoolTipFont}>
                                                            If you are an employee of {subDomainName}, click on this.
                                                        </Typography>
                                                        {/* <em>{"And here's"}</em> <b>{'some'}</b> <u>{'amazing content'}</u>.{' '}
                                                    {"It's very engaging. Right?"} */}
                                                    </React.Fragment>
                                                }
                                            >
                                                <FormControlLabel className="fontRubik" value="OTHERS" control={<Radio />} label="Other" />
                                            </BootstrapTooltip>
                                        </RadioGroup>
                                    </div>
                                    <form className="w100 mt30" onSubmit={formik.handleSubmit}>
                                        <Grid container spacing={3}>
                                            {/* {(subDomainName === "itec") ? (
                                        <Grid item xs={12} sm={12}>
                                            <FormControl fullWidth>
                                                <InputLabel className="lbl" htmlFor="tennantName" shrink>
                                                    {' '}
                                                    Select Domain
                                            </InputLabel>
                                                <Select
                                                    native
                                                    name="tennantName"
                                                    onChange={formik.handleChange}
                                                    value={formik.values.tennantName}
                                                    className={clsx(classes.bottomLine)}
                                                    onClick={onImcChange}
                                                >
                                                    <option value="" selected>
                                                        Select IMC
                                                </option>
                                                    {allImcsOptions(AllImcs)}
                                                </Select>
                                                {formik.touched.tennantName && formik.errors.tennantName ? (
                                                    <span className={classes.errorDiv}>{formik.errors.tennantName}</span>
                                                ) : null}
                                            </FormControl>
                                        </Grid>) : ''} */}
                                            <Grid item xs={12} sm={12}>
                                                <FormControl fullWidth>
                                                    <InputLabel className="lbl" htmlFor="person2Mobnumber" shrink>
                                                        {' '}
                                                        Email Address
                                                    </InputLabel>

                                                    <Input
                                                        className="bottom"
                                                        fullWidth
                                                        id="email"
                                                        name="email"
                                                        autoComplete="email"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.email}
                                                        placeholder="Enter Email"
                                                        onClick={() => setError('')}
                                                    />
                                                    {formik.touched.email && formik.errors.email ? (
                                                        <span className={classes.errorDiv}>{formik.errors.email}</span>
                                                    ) : null}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <FormControl fullWidth>
                                                    <InputLabel className="lbl" htmlFor="person2Mobnumber" shrink>
                                                        {' '}
                                                        Password
                                                    </InputLabel>
                                                    <Input
                                                        fullWidth
                                                        name="password"
                                                        className="bottom"
                                                        type={values.showPassword ? 'text' : 'password'}
                                                        id="password"
                                                        autoComplete="current-password"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.password}
                                                        placeholder="Enter Password"
                                                        onClick={() => setError('')}
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={() => setValues({ showPassword: !values.showPassword })}
                                                                >
                                                                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                    />
                                                    {formik.touched.password && formik.errors.password ? (
                                                        <span className={classes.errorDiv}>{formik.errors.password}</span>
                                                    ) : null}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12} className={classes.selectmainDiv} style={{ display: companyDiv }}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-controlled-open-select-label" className="lbl" shrink>
                                                        Corporate/Company name
                                                    </InputLabel>
                                                    {companyList && (
                                                        <Select
                                                            native
                                                            className={clsx(classes.bottomLine)}
                                                            labelId="demo-controlled-open-select-label"
                                                            id="demo-controlled-open-select"
                                                            name="companyName"
                                                            onChange={handleCompChange}
                                                            value={selCompany}
                                                        >
                                                            <option value="" selected>
                                                                Select corporate/Company
                                                            </option>
                                                            {imcCompanyOptions(companyList)}
                                                        </Select>
                                                        // <Select
                                                        //     native
                                                        //     name="tennantName"
                                                        //     onChange={handleCompChange}
                                                        //     value={selCompany}
                                                        //     className={clsx(classes.bottomLine)}
                                                        // >
                                                        //     <option value="" selected>
                                                        //         Select IMC
                                                        //     </option>
                                                        //     {companyList}
                                                        // </Select>
                                                    )}
                                                    <p className={classes.errorDiv}>{errorCorporate}</p>
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12}>
                                                <Link
                                                    to="/forgotpassword"
                                                    className="forgotpass"
                                                    variant="body2"
                                                    style={{ textDecoration: 'underline' }}
                                                >
                                                    Forgot password?
                                                </Link>
                                            </Grid>
                                            <Grid item xs={12} sm={12} style={{ paddingBottom: '10px' }}>
                                                {(showLoader && (
                                                    <Button className={classes.submit} variant="outlined" fullWidth disabled>
                                                        <CircularProgress color="primary" size={24} />
                                                    </Button>
                                                )) || (
                                                    <Button
                                                        type="submit"
                                                        onClick={() => formik.onSubmit}
                                                        fullWidth
                                                        variant="contained"
                                                        color="primary"
                                                        className={classes.button}
                                                        disabled={loginbtnStatus}
                                                    >
                                                        Login
                                                    </Button>
                                                )}
                                                <p className={classes.errorDiv} style={{ textAlign: 'center' }}>
                                                    {error}
                                                </p>
                                            </Grid>
                                        </Grid>
                                    </form>

                                    <Dialog
                                        // onClose={handleClose}
                                        PaperProps={{
                                            className: 'QandADailogBox',
                                            style: { padding: '6px 12px 0px 12px', maxWidth: '400px', minWidth: '400px' },
                                        }}
                                        aria-labelledby="form-dialog-title"
                                        open={handleOpen}
                                        clear={clearDataNew}
                                    >
                                        {/* <DialogTitle id="form-dialog-title">
                                        Upload File
                                    </DialogTitle> */}
                                        <div className="main-container w100">
                                            <DialogContent style={{ textAlign: 'center', padding: '20px 10px' }}>
                                                <form onSubmit={otpSubmit}>
                                                    <FormControl fullWidth>
                                                        <InputLabel className="lbl" htmlFor="otp" shrink>
                                                            {' '}
                                                            Enter OTP
                                                        </InputLabel>
                                                        <Input
                                                            className="bottom"
                                                            required
                                                            fullWidth
                                                            id="otp"
                                                            label="OTP"
                                                            name="otp"
                                                            value={otpdata}
                                                            // className={classes.bottomLine}
                                                            inputProps={{ maxLength: 4 }}
                                                            autoComplete="off"
                                                            placeholder="Enter OTP"
                                                            onChange={(e) => {
                                                                storeOTPvalue(e);
                                                            }}
                                                        />
                                                    </FormControl>
                                                    <div style={{ textAlign: 'right', marginTop: '5px' }}>
                                                        <span
                                                            // className="forgotpass"
                                                            variant="body2"
                                                            onClick={() => {
                                                                resndOTP(formik.values);
                                                            }}
                                                            className={!resendDisable ? classes.resendButton : classes.pointerEvents}
                                                        >
                                                            Resend OTP
                                                        </span>
                                                    </div>

                                                    <div>
                                                        <div className={classes.errorDiv}> {errorMessage}</div>
                                                        {(showLoaderSubmit && (
                                                            <div className="mt15">
                                                                <Button
                                                                    className={classes.submit}
                                                                    variant="outlined"
                                                                    disabled
                                                                    style={{ width: '150px' }}
                                                                >
                                                                    <CircularProgress size={24} />
                                                                </Button>
                                                            </div>
                                                        )) || (
                                                            <div className="mt15">
                                                                <Button
                                                                    type="submit"
                                                                    className={classes.buttonSml}
                                                                    onClick={otpSubmit}
                                                                    variant="contained"
                                                                    color="primary"
                                                                >
                                                                    Submit
                                                                </Button>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="mt15">
                                                        <Link
                                                            onClick={handleClose}
                                                            className="forgotpass"
                                                            variant="body2"
                                                            style={{ textDecoration: 'underline' }}
                                                        >
                                                            Back to Login
                                                        </Link>
                                                    </div>
                                                </form>
                                            </DialogContent>
                                        </div>
                                    </Dialog>
                                    <div style={{ display: otpDiv }}>
                                        <div>
                                            <span className={classes.success}>{OTPmsg}</span>
                                        </div>
                                    </div>

                                    {/* <FormControl fullWidth>
                                        <InputLabel className="lbl" htmlFor="otp" shrink>
                                            {' '}
                                            Enter OTP
                                        </InputLabel>
                                        <Input
                                            className="bottom"
                                            required
                                            fullWidth
                                            id="otp"
                                            label="OTP"
                                            name="otp"
                                            className={classes.bottomLine}
                                            inputProps={{ maxLength: 4 }}
                                            autoComplete="off"
                                            placeholder="Enter OTP"
                                            onChange={(e) => {
                                                storeOTPvalue(e);
                                            }}
                                        />
                                    </FormControl> */}
                                    {/* <div style={{ textAlign: 'right', marginTop: '5px' }}>
                                        <span
                                            // to=""
                                            className="forgotpass"
                                            variant="body2"
                                            style={{ textDecoration: 'underline' }}
                                            onClick={() => { resndOTP(formik.values) }}
                                        >
                                            Resend OTP
                                        </span>
                                    </div> */}

                                    {/* <div className={classes.errorDiv}> {errorMessage}</div>
                                    {(showLoaderSubmit && (
                                        <div className="mt15">
                                            <Button className={classes.submit} variant="outlined" fullWidth disabled>
                                                <CircularProgress size={24} />
                                            </Button>
                                        </div>
                                    )) || (
                                            <div className="mt15">
                                                <Button
                                                    type="button"
                                                    className={classes.button}
                                                    onClick={otpSubmit}
                                                    fullWidth
                                                    variant="contained"
                                                    color="primary"
                                                >
                                                    Submit
                                                </Button>
                                            </div>
                                        )}
                                </div> */}
                                </div>
                            </div>
                        </Container>
                    </div>
                ) : null}
                {handleLogo ? <PrivacyFooter /> : null}
            </div>
            {showDialogBoxTerms && <TermsCondition showDialogBoxTerms={showDialogBoxTerms} handleTermsClose={handleTermsClose} />}
        </>
    );
}
export default Login;
